<template>
  <div class="brand-ad-top-banner" :class="{'active-in-app': inApp}">
    <div class="top-banner-img" ></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  props: {
    inApp: Boolean
  },
}
</script>

<style lang="scss">
.brand-ad-home {
  .brand-ad-top-banner {
    margin: 0 auto;
    width: 750px;
    height: 286px;
    overflow: hidden;
    .top-banner-img {
      margin: 0 auto;
      width: 592px;
      height: 308px;
      background: url('../assets/image/logo.png');
      background-size: cover;
    }
    &.active-in-app {
      height: 316px;
      .top-banner-img {
        margin: 0 auto;
        width: 674px;
        height: 340px;
        background: url('../assets/image/logo-scale.png');
        background-size: cover;
      }
    }
  }
}
</style>